var AdaptiveImage = require( "../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "06f85de910cd2046ebb7248b17fe3fd0.png",
    width: 341,
    height: 103
});